// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input, OnChanges } from '@angular/core';
import { Tooltip } from '@coa/app/shared/unique-visits-chart/model/tooltip';
import { Observable } from 'rxjs';
import { DateAggregationService } from '@coa/app/core/services/date-aggregation/date-aggregation.service';
import { FeatureToggleService } from '@coa/app/shared/feature-toggle/services/feature-toggle.service';
import { map } from 'rxjs/operators';
import { ClientDateAggregationType } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { FeatureToggle } from '@coa/app/shared/feature-toggle/models/feature.toggle';

@Component({
  selector: 'coa-multiple-series-chart-tooltip',
  templateUrl: './multiple-series-chart-tooltip.component.html',
  styleUrls: ['./multiple-series-chart-tooltip.component.scss'],
})
export class MultipleSeriesChartTooltipComponent implements OnChanges {
  @Input() tooltip: Tooltip;
  @Input() clientId: string;

  isDaily$: Observable<boolean>;
  paymentsEnabled$: Observable<boolean>;

  constructor(
    private dateAggregationService: DateAggregationService,
    private featureToggleService: FeatureToggleService,
  ) {
  }

  ngOnChanges(): void {
    if (!this.clientId) {
      return;
    }
    this.isDaily$ = this.dateAggregationService.getAggregationTypes(this.clientId)
      .pipe(map((type) => type === ClientDateAggregationType.DAILY));
    this.paymentsEnabled$ = this.featureToggleService.isFeatureAdded(FeatureToggle.PAYMENT_EVENTS_ENABLED, this.clientId);
  }
}
